import React from 'react';
import { Flex } from 'rebass/styled-components';

import { RewardsRibbon, RibbonColorPallettes } from 'shared/assets/rewards-ribbon';
import { StyledCheckoutAccordionSummary, SuccessText } from 'checkout/components/sections/rewards/styles';

export function RewardsConnectSuccessSummary() {
  return (
    <StyledCheckoutAccordionSummary>
      <Flex alignItems='center'>
        <RewardsRibbon pallette={RibbonColorPallettes.green} height={35.36} width={35.36} />
        <SuccessText>Connected! Scroll down to view discounts</SuccessText>
      </Flex>
    </StyledCheckoutAccordionSummary>
  );
}
